import { Injectable } from '@angular/core';
import * as L from 'leaflet';
import { Router, ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { ConstantsModule } from 'src/app/common/constants/constants.module';
import { HttperrorhandlerService } from 'src/app/common/http/httperrorhandler.service';
import { MapconstantsModule } from 'src/app/components/geoportal/gis/mapconstants/mapconstants.module';
import { UtilsModule } from 'src/app/common/utils/utils.module';
import { AuthloginService } from '../login/authlogin.service';

@Injectable({
  providedIn: 'root'
})
export class GisService {
  urlData: Object
  activeFeatureData: Object = {
    "id": null,
    "uuid": null,
    "layer": null
  };
  previousFeatureData: Object = {
    "id": null,
    "uuid": null,
    "layer": null
  };
  logindetails: any;
  constructor(
    private constants: ConstantsModule,
    private http: HttpClient,
    private errorHandler: HttperrorhandlerService,
    private mapConstantsModule: MapconstantsModule,
    private sessionlogin: AuthloginService,
    private utils: UtilsModule,
    private router: Router,
    private route: ActivatedRoute
  ) { }

  addTileLayer(layerOptions) {
    let tileLayer = new L.TileLayer(layerOptions.url, { attribution: layerOptions.attribution });
    return tileLayer;
  }

  addWMSLayer(layerOptions) {
    let wmsLayer = new L.TileLayer.WMS(layerOptions.url, {
      layers: layerOptions.layerName,
      styles: layerOptions.style,
      format: "image/png",
      transparent: true,
      attribution: layerOptions.attribution || "",
      minZoom: layerOptions.minzoom,
      maxZoom: layerOptions.maxzoom,
      pane: layerOptions.pane,
      ...{ 'CQL_FILTER': layerOptions.cql_filter }
    });

    return wmsLayer;
  }

  getassesmentYear(): any {
    let api = "getassesmentYear";
    return ['2016-2017', '2017-2018', '2018-2019', '2019-2020', '2020-2021', '2021-2022', '2022-2023'];
  }

  getLocationHierarchy(options) {
    let url = this.constants.API_URL + 'locations/heirarchy';
    let params = {
      locName: options['locname'],
      locUUID: options['locuuid'],
      locType: options['loctype'],
      stateUUID: options['stateuuid'] ? options['stateuuid'] : '609c5df4-6414-4bbd-a22d-ff5fbdad6836',
      view: options['view'],
    };

    return this.http.post<any>(url, params).pipe(
      catchError(this.errorHandler.handleError('Location Hierarchy service : ', []))
    );
  }
  getUUIDvsColorMap(rankData) {
    let Map = {}
    // console.log("rrere",rankData);

    if (rankData && Object.keys(rankData).length > 0) {
      Object.keys(rankData).forEach(state => {
        if (rankData[state] && rankData[state].length > 0) {
          rankData[state].forEach(dist => {
            if (dist && Object.keys(dist).length > 0) {
              Object.keys(dist).forEach(distname => {
                // console.log('distttttttttt',dist);
                let uuid = dist[distname]['uuid'];
                let score = dist[distname]['score'].toFixed(2);
                // Map[uuid]= score;
                Map[uuid] = { "color": this.getRankColor(score), "score": score };

              });
            }
          });
        }
      });
    }
    // console.log("\n\n ------------- Map ----------- ",Map);

    return Map;

  }

  getRankColor(score) {
    if (score != null && score != undefined) {
      if (score > 65) return "rgb(142, 232, 124)";
      else if (score > 50) return "rgb(255, 228, 129)";
      return "rgb(245, 97, 97)";
    }
    return "#222";
  }
  // getRankingParams(urlParams) {
  //   let postdata = {};

  //   postdata['ay'] = urlParams['assesmentyear'] || "2020-2021";
  //   postdata['view'] = this.constants.VIEWS['admin'];
  //   postdata['cList'] = urlParams['district'] ? urlParams['district'].split(',') : ['ALL'];
  //   postdata['pType'] = this.constants.LOCATION_CONSTANT['STATE'];
  //   postdata['cType'] = this.constants.LOCATION_CONSTANT['DISTRICT'];
  //   // postdata['pID'] = urlParams['loctype'] == 'COUNTRY' ? this.constants.REGIONKEY :  this.urlParams['stateuuid']
  //   postdata['pID'] = null;
  //   postdata['subTp'] = urlParams['month'];
  //   return postdata;
  // }
  getRankingParams(urlParams) {
    let currMonth=(new Date().getMonth() + 1).toString() ;
    let postdata = {};
    if (currMonth.length<2){
      currMonth='0'+currMonth;
    }
    let currAY= new Date().getFullYear().toString() + '-' + (new Date().getFullYear() + 1).toString() ;
    console.log('crrdate',currAY)
    postdata['ay'] = urlParams['assesmentyear'] || currAY;
    postdata['view'] = this.constants.VIEWS['admin'];
    postdata['cList'] = urlParams['district'] ? urlParams['district'].split(',') : ['ALL'];
    // postdata['cList']=['ALL'];
    postdata['pType'] = this.constants.LOCATION_CONSTANT['STATE'];
    postdata['cType'] = this.constants.LOCATION_CONSTANT['DISTRICT'];
    // postdata['pID'] = urlParams['loctype'] == 'COUNTRY' ? this.constants.REGIONKEY :  this.urlParams['stateuuid']
    postdata['pID'] = null;
    postdata['subTp'] = urlParams['month'] || currMonth;
    return postdata;
  }

  addVectorLayer(layerOptions, map, activeLayers, activeFeatureData, allowclick, layerdata = null, login) {
    let vectorLayerArr = [];
    let vectorLayerList
    vectorLayerArr.push(layerOptions);
    // console.log(" in addVectorLayer");
    let uuidVsColorMap = null
    if (layerOptions.hasFormatting == true) {
      if (layerOptions.layer_name == 'DISTRICT') {
        uuidVsColorMap = this.getUUIDvsColorMap(layerdata);
        // console.log('uuid vs colormap',uuidVsColorMap);
      }
      if (layerOptions.layer_name == 'DISTRICT_ATTENDENCE') {
        uuidVsColorMap = layerdata;
      }

    }
    vectorLayerList = this.setVECTORLayersForConstant(map, this.getVectorOverlaysForState(vectorLayerArr, null, uuidVsColorMap, login), activeFeatureData, activeLayers, allowclick, uuidVsColorMap, login);

    return vectorLayerList
  }

  getVectorOverlaysForState(data: any, cqlFilter: any, uuidVsColorMap = null, login) {
    // console.log(data)
    let overlays: any = {};
    data.forEach(element => {
      // console.log(element)
      let overlay: any = {};
      overlay.type = 'vector';
      overlay.layerOptions = {};
      overlay.layerOptions.interactive = true;
      overlay.layerOptions.rendererFactory = (L as any).canvas.tile;
      overlay.url = element.url;
      overlay.layerOptions.inputtype = element.inputtype;
      overlay.layerOptions.style = element.style;
      if (element.cql_filter) {
        overlay.url += '&cql_filter=' + element.cql_filter;
      }
      overlay.url += '&buffer=' + 100;
      overlay.layerOptions.pane = element.layeroptions_pane;
      overlay.layerOptions.minZoom = element.layeroptions_min_zoom;
      overlay.layerOptions.maxZoom = element.layeroptions_max_zoom;
      overlay.layerOptions.pane = element.layeroptions_pane;
      overlay.layerOptions.visible = element.visible;
      overlay.layerOptions.vectorTileLayerStyles = {};
      // console.log("element",element);

      if (element.layer_name == 'DISTRICT') {
        let _that = this;
        // console.log("overlay.layerOptions.vectorTileLayerStyles",overlay.layerOptions.vectorTileLayerStyles);
        // console.log("overlay getVectorOverlaysForState",overlay);

        overlay.layerOptions.vectorTileLayerStyles["districts"] = function (properties,) {
          // console.log("kkll",properties);

          let style = { opacity: 1, weight: 0.4, color: "#000000", fill: false, fillColor: "#222" };
          if (properties.y_n == 'Y') {
            style.fill = true;
            if (properties.dgc == 'Y') {
              if (properties.dgc_type == 2) {
                style.fillColor = "#90EE90";
                //style.fillColor ="rgba(144, 238, 144,0.5)";
                // style['fillOpacity']=1;
              } else if (properties.dgc_type == 1) {
                // style.fillColor ="rgba(40, 250, 40,0.5)";
                //style.fillColor='#F6B531'
                style.fillColor = "#006400";
              }
              style['fillOpacity'] = 0.4;
            } else {
              style.weight = 0.2;
              style['fillOpacity'] = 0.1;
            }
          } else {
            style.weight = 0.1;
          }
          // if(uuidVsColorMap && uuidVsColorMap[properties.loc_uuid]){
          //   style.fillColor =uuidVsColorMap[properties.loc_uuid]["color"];
          //   style.fillOpacity=0.6;
          // }  
          // console.log("style",style);

          return style;
        };
      }

      if (element.layer_name == 'DISTRICT_ATTENDENCE') {
        let _that = this;
        overlay.layerOptions.vectorTileLayerStyles["districts_new"] = function (properties,) {
          let style = { opacity: 1, weight: 0.4, color: "#000000", fill: false, fillColor: "red", fillOpacity: 1 };
          if (login.roles[0] == "ADMIN") {
            if (properties.y_n == 'Y') {
              style.fill = true;
              // console.log(" uuidVsColorMap ::: ",uuidVsColorMap ,properties.loc_uuid )
              if (uuidVsColorMap != null && uuidVsColorMap.hasOwnProperty(properties.loc_uuid)) {
                if (uuidVsColorMap[properties.loc_uuid] != null && uuidVsColorMap[properties.loc_uuid].hasOwnProperty('percent')) {
                  let percent = uuidVsColorMap[properties.loc_uuid]['percent'];
                  if (percent > 99) {
                    style.fillColor = "#50C878";
                  } else if (percent >= 50) {
                    style.fillColor = "#FFFF00";
                  } else if (percent >= 1 && percent < 50) {
                    style.fillColor = "#FF7F50"
                  } else {
                    style.fillColor = "#8B0000";
                  }
                } else {
                  style.fillColor = "#808080";
                }

              } else {
                style.fillColor = "#808080";
              }
              if (uuidVsColorMap[properties.loc_uuid] != null && uuidVsColorMap[properties.loc_uuid].hasOwnProperty('nolatest')) {
                if (uuidVsColorMap[properties.loc_uuid]['nolatest'])
                  style.fillColor = "#8B0000";
              }

            } else {
              style.weight = 0;
            }

          }
          else {
            let v: any = login.loggedUserData.userProfile.locationType;
            let nam: any = login.loggedUserData.userProfile.locationName;
            let str: any = v == 'STATE' ? 'state' : 'district';
            if (properties[str].toLowerCase() == nam.toLowerCase()) {
              style.fill = true;
              // console.log(" uuidVsColorMap ::: ",uuidVsColorMap ,properties.loc_uuid )
              if (uuidVsColorMap != null && uuidVsColorMap.hasOwnProperty(properties.loc_uuid)) {
                if (uuidVsColorMap[properties.loc_uuid] != null && uuidVsColorMap[properties.loc_uuid].hasOwnProperty('percent')) {
                  let percent = uuidVsColorMap[properties.loc_uuid]['percent'];
                  if (percent > 99) {
                    style.fillColor = "#50C878";
                  } else if (percent >= 50) {
                    style.fillColor = "#FFFF00";
                  } else if (percent >= 1 && percent < 50) {
                    style.fillColor = "#FF7F50"
                  } else {
                    style.fillColor = "#8B0000";
                  }
                } else {
                  style.fillColor = "#808080";
                }

              } else {
                style.fillColor = "#808080";
              }
              if (uuidVsColorMap[properties.loc_uuid] != null && uuidVsColorMap[properties.loc_uuid].hasOwnProperty('nolatest')) {
                if (uuidVsColorMap[properties.loc_uuid]['nolatest'])
                  style.fillColor = "#8B0000";
              }

            } else {
              style.weight = 0;
            }

          }
          return style;
        };
      }

      overlay.layerOptions.vectorTileLayerStyles["district_basin"] = function (properties,) {
        let style = { opacity: 1, weight: 0.4, color: "#000000", fill: true, fillColor: "#222", fillOpacity: 0 };
        // console.log(properties)
        if (properties.y_n == 'Y') {
          style.fill = true;
          if (properties.dgc == 'Y') {
            if (properties.dgc_type == 2) {
              style.fillColor = "#90EE90";
            } else if (properties.dgc_type == 1) {
              style.fillColor = "#006400";
            }
            style['fillOpacity'] = 0.4;
          } else {
            style.weight = 0.2;
            style['fillOpacity'] = 0.1;
          }
        } else {
          style.weight = 0.1;
        }
        // if(uuidVsColorMap && uuidVsColorMap[properties.loc_uuid]){
        //   style.fillColor =uuidVsColorMap[properties.loc_uuid]["color"];
        //   style.fillOpacity=0.6;
        // }          
        return style;
      };


      overlay.layerOptions.getFeatureId = function (feature) {
        return feature.properties.loc_uuid;
      }
      // }

      // if (element.type === 'VECTOR1') {
      // if (element.application_type === null || element.application_type[application] === true) 
      {
        overlays[element.layer_name] = overlay;
      }
      // }
    })
    return overlays;
  }
  public setVECTORLayersForConstant(mapObj: L.Map, VECTORLayers: any, activeFeatureData, activeLayers, allowclick, uuidVsColorMap, login): any {
    let layers: any = {};
    let parms
    // console.log("VECTORLayers",VECTORLayers,"uuid Vs COlor Map",uuidVsColorMap);

    for (let key in VECTORLayers) {
      let layer = VECTORLayers[key];
      // console.log(layer)
      let vectorTileLayer = (L as any).vectorGrid.protobuf(layer.url, layer.layerOptions);
      // console.log(vectorTileLayer)
      vectorTileLayer.on({

        click: (e: L.LayerEvent) => {
          if (allowclick) {
            let layer = e.layer;
            let uuid = e.layer['properties']['uuid'];

            if (uuid != activeFeatureData["uuid"]) {
              e.layer["options"].color = '#000000';
              let bounds;
              if (activeFeatureData["uuid"] != undefined && activeFeatureData["uuid"] != null) { }
              let properties = layer['properties'];
              activeFeatureData["uuid"] = properties['uuid'];
              let latLng = e["latlng"];
              mapObj.setView([latLng.lat, latLng.lng], 7);
              this.onLocationClick(properties['state_name'], properties['uuid'], 'STATE', bounds);

            }
          }
        },
        mouseover: (e: L.LayerEvent) => {
          // console.log("e VECTORLayers",e);
          // console.log("key",key);
          // console.log("uuidVsColorMap",uuidVsColorMap);



          // console.log('EEEEEEEEEEEEE ::',e);
          // console.log('key==',key);
          if(e.layer['properties']['state'] == "UTTAR PRADESH" || e.layer['properties']['state'] == "BIHAR" || e.layer['properties']['state'] == "WEST BENGAL" || e.layer['properties']['state'] == "UTTARAKHAND" || e.layer['properties']['state'] == "JHARKHAND"){
          if (key == "DISTRICT" && login != null) {
            if (login.roles[0] == "ADMIN") {
              if (e.layer['properties']['y_n'] == 'Y') {
                let score = uuidVsColorMap[e.layer['properties']['loc_uuid']] ? uuidVsColorMap[e.layer['properties']['loc_uuid']]["score"] : '-'
                L.popup({ autoPan: false, closeButton: false }).setLatLng([e['latlng'].lat, e['latlng'].lng])
                  .setContent("<table><tr><td>District  : </td><td>" + this.converts(e.layer['properties']['district']) + "</td></tr><tr><td> State   :</td><td>" + this.convert(e.layer['properties']['state']) +
                    "</td></tr><tr><td>Score :</td><td>" + score + "</td></tr></table>").openOn(mapObj);
              }
            }
            else {
              let v: any = login.loggedUserData.userProfile.locationType;
              let nam: any = login.loggedUserData.userProfile.locationName;
              let str: any = v == 'STATE' ? 'state' : 'district';
              if (e.layer['properties'][str].toLowerCase() == nam.toLowerCase()) {
                let score = uuidVsColorMap[e.layer['properties']['loc_uuid']] ? uuidVsColorMap[e.layer['properties']['loc_uuid']]["score"] : '-'
                L.popup({ autoPan: false, closeButton: false }).setLatLng([e['latlng'].lat, e['latlng'].lng])
                  .setContent("<table><tr><td>District  : </td><td>" + this.converts(e.layer['properties']['district']) + "</td></tr><tr><td> State   :</td><td>" + this.convert(e.layer['properties']['state']) +
                    "</td></tr><tr><td>Score :</td><td>" + score + "</td></tr></table>").openOn(mapObj);
              }
            }
          }


          if (key == "DISTRICT_ATTENDENCE" && login != null) {
            if (login.roles[0] == "ADMIN") {
              if (e.layer['properties']['y_n'] == 'Y') {
                if (e.layer['options']['fillColor'] != "#808080"){
                let count = uuidVsColorMap[e.layer['properties']['loc_uuid']] ? uuidVsColorMap[e.layer['properties']['loc_uuid']]["count"] : '-';
                let tcount = uuidVsColorMap[e.layer['properties']['loc_uuid']] ? uuidVsColorMap[e.layer['properties']['loc_uuid']]["tcount"] : '-';
                let percent = uuidVsColorMap[e.layer['properties']['loc_uuid']] ? uuidVsColorMap[e.layer['properties']['loc_uuid']]["percent"] : '-';
                // e.layer['properties']['state']=this.titleCasePipe.transform(e.layer['properties']['state']);
                L.popup({ autoPan: false, closeButton: false }).setLatLng([e['latlng'].lat, e['latlng'].lng])
                  .setContent("<table><tr><td>District  : </td><td>" + this.converts(e.layer['properties']['district']) + "</td></tr><tr><td> State   :</td><td>" + this.convert(e.layer['properties']['state']) +
                    "</td></tr><tr><td> Meetings Held : </td><td>" + count + "</td></tr><tr><td> Total meetings   :</td><td>" + tcount +
                    "</td></tr><tr><td>Meetings Percentage(%) :</td><td>" + percent + "</td></tr></table>").openOn(mapObj);
                }
              }
            }
            else {
              let v: any = login.loggedUserData.userProfile.locationType;
              let nam: any = login.loggedUserData.userProfile.locationName;
              let str: any = v == 'STATE' ? 'state' : 'district';
              if (e.layer['properties'][str].toLowerCase() == nam.toLowerCase()) {
                if (e.layer['options']['fillColor'] != "#808080"){
                let count = uuidVsColorMap[e.layer['properties']['loc_uuid']] ? uuidVsColorMap[e.layer['properties']['loc_uuid']]["count"] : '-';
                let tcount = uuidVsColorMap[e.layer['properties']['loc_uuid']] ? uuidVsColorMap[e.layer['properties']['loc_uuid']]["tcount"] : '-';
                let percent = uuidVsColorMap[e.layer['properties']['loc_uuid']] ? uuidVsColorMap[e.layer['properties']['loc_uuid']]["percent"] : '-';
                // e.layer['properties']['state']=this.titleCasePipe.transform(e.layer['properties']['state']);
                L.popup({ autoPan: false, closeButton: false }).setLatLng([e['latlng'].lat, e['latlng'].lng])
                  .setContent("<table><tr><td>District  : </td><td>" + this.converts(e.layer['properties']['district']) + "</td></tr><tr><td> State   :</td><td>" + this.convert(e.layer['properties']['state']) +
                    "</td></tr><tr><td> Meetings Held : </td><td>" + count + "</td></tr><tr><td> Total meetings   :</td><td>" + tcount +
                    "</td></tr><tr><td>Meetings Percentage(%) :</td><td>" + percent + "</td></tr></table>").openOn(mapObj);
                }
              }
            }

          }
        }
        },
        mouseout: (e: L.LayerEvent) => {
          mapObj.closePopup();
        }

      })

      layers[key] = vectorTileLayer;
      // console.log(vectorTileLayer)
      if (vectorTileLayer.options.visible) {
        activeLayers[key] = true;
        if (!mapObj.hasLayer(vectorTileLayer))
          mapObj.addLayer(vectorTileLayer);
        // console.log(mapObj)
      } else {
        activeLayers[key] = false;
      }

    }

    return layers;
  }

  convert(txt: any) {
    txt.toLowerCase();
    txt = txt.split(/(\s+)/);
    if (txt.length > 1) {
      let a: any = txt[0].charAt(0).toUpperCase() + txt[0].substr(1).toLowerCase();
      let b: any = txt[2].charAt(0).toUpperCase() + txt[2].substr(1).toLowerCase();
      return a + ' ' + b;
    }
    else {
      let a: any = txt[0].charAt(0).toUpperCase() + txt[0].substr(1).toLowerCase();
      return a;
    }
  }

  converts(txt: any) {
    txt.toLowerCase();
    txt = txt.split(/(\s+)/);
    if(txt.length == 7){
    let a: any = txt[0].charAt(0).toUpperCase() + txt[0].substr(1).toLowerCase();
    let b: any = txt[2].charAt(0).toUpperCase() + txt[2].substr(1).toLowerCase();
    let c: any = txt[4].charAt(0).toUpperCase() + txt[4].substr(1).toLowerCase();
    let d: any = txt[6].charAt(0).toUpperCase() + txt[6].substr(1).toLowerCase();
    // let b:any=txt[2].charAt(0).toUpperCase()
    return a + ' ' + b + ' ' + c + ' ' + d;
    }
    else if(txt.length == 5){
      let a: any = txt[0].charAt(0).toUpperCase() + txt[0].substr(1).toLowerCase();
    let b: any = txt[2].charAt(0).toUpperCase() + txt[2].substr(1).toLowerCase();
    let c: any = txt[4].charAt(0).toUpperCase() + txt[4].substr(1).toLowerCase();
    return a + ' ' + b + ' ' + c;
    }
    else if(txt.length == 3){
      let a: any = txt[0].charAt(0).toUpperCase() + txt[0].substr(1).toLowerCase();
    let b: any = txt[2].charAt(0).toUpperCase() + txt[2].substr(1).toLowerCase();
    return a + ' ' + b;
    }
    else {
      let a: any = txt[0].charAt(0).toUpperCase() + txt[0].substr(1).toLowerCase();
      return a;
    }
  }

  setActiveFeatureData(uuid: number, locType: string) {
    this.previousFeatureData = JSON.parse(JSON.stringify(this.activeFeatureData));
    this.activeFeatureData["uuid"] = uuid;
    this.activeFeatureData["layer"] = locType.toUpperCase();
    this.activeFeatureData["id"] = null;
  }
  onLocationClick(loc_name: string, loc_UUID: string, locType: string, bounds: L.LatLngBounds) {

    let urlParams = Object.assign(this.urlData, { "locname": loc_name, "locuuid": loc_UUID, "loctype": locType });
    let rainfallHM = { "mapOnClickParams": "true" };
    urlParams = Object.assign(urlParams, rainfallHM);
    if (urlParams['loctype'] == 'STATE') {
      urlParams['stateuuid'] = urlParams['locuuid'];
    }
    let parentLocation = urlParams['parentLocName'];
    urlParams['view'] = "ADMIN";
    this.router.navigate(["/gis", "INDIA", urlParams]);
  }

  addLegendToModal(layerName, layerObj, htmllegend) {
    let legendData = this.mapConstantsModule.LEGEND_DATA[layerName];
    if (!legendData || !htmllegend) return;
    let legendInfoData = this.getLegendData(legendData, layerObj);
    // console.log("legendInfoData :::",legendInfoData);

    htmllegend.addLegend(legendInfoData)
    return true;

  }
  getBlock(filter) {
    let layerURL = this.mapConstantsModule.gisIP + "/geoserver/gdpms/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=gdpms%3Adistricts&maxFeatures=50&outputFormat=application%2Fjson" as string;
    if (filter)
      layerURL += '&cql_filter=' + filter;
    return this.http.get(layerURL).pipe(
      catchError(this.errorHandler.handleError('Rainfall sensor data request', []))
    );
  }

  getLegendData(data, layerInstance) {
    let legend = {
      name: data.title,
      layer: layerInstance,
      elements: []
    }

    if (data.HTML || data.image) {
      let html = data.HTML ? data.HTML : "<img style='width: 20px;' src='" + data.image + "'/>";
      legend.elements.push({ html: html });
    }
    else if (data.levels) {
      let obj;
      if (!(data.levels instanceof Array)) {
        let periodWiseLegend = {};
        for (let period in data.levels) {
          let tempLegend = {
            name: data.title,
            layer: layerInstance,
            elements: []
          };

          data.levels[period].forEach(level => {
            obj = {};
            obj["html"] = '';
            if (level['image'] != undefined && level['image'] != '')
              obj["html"] = "<img style='width:13px;height:13px;' src='" + level['image'] + "'/>";

            obj["label"] = level.name;

            obj["style"] = { 'background-color': level.color, 'width': '13px', 'height': '13px' };
            tempLegend.elements.push(obj);
          });

          periodWiseLegend[period] = tempLegend;
        }
        return periodWiseLegend;
      }
      else {
        data.levels.forEach(level => {
          obj = {};
          obj["html"] = '';
          if (level['image'] != undefined && level['image'] != '')
            obj["html"] = "<img style='width:13px;height:13px;' src='" + level['image'] + "'/>";
          obj["label"] = level.name;
          obj["style"] = { 'background-color': level.color, 'width': '13px', 'height': '13px' };
          legend.elements.push(obj);
        });
      }
    }
    return legend;
  }
  // convertKeysto(list,type,wholedata,statedistrict){
  //     let keys = [];
  //     if(statedistrict == 'statewise'){
  //       if(type == "ota"){
  //         list.forEach(element => {
  //           keys.push(element['item_id']);
  //         });
  //       } else {
  //         wholedata.forEach(element => {
  //           list.forEach(id => {
  //             if(id == element['item_id']){
  //               keys.push(element);
  //             }
  //           });
  //         });
  //       }
  //     } else{
  //       if(type == "ota"){
  //         list.forEach(element => {
  //           keys.push(element['uuid']);
  //         });
  //       } else {
  //         wholedata.forEach(element => {
  //           list.forEach(id => {
  //             if(id == element['uuid']){
  //               keys.push(element);
  //             }
  //           });
  //         });
  //       }

  //     }

  //     return keys;
  //   }
  setUrlData(urlData: Object) {
    this.urlData = urlData;
  }
  convertdata(list, type, wholedata) {
    let keys = [];
    if (type == "ota") {
      list.forEach(element => {
        keys.push(element['uuid']);
      });
    } else {
      wholedata.forEach(element => {
        list.forEach(id => {
          if (id == element['uuid']) {
            keys.push(element);
          }
        });
      });
    }

    return keys;
  }

  getUrlData(): Object {
    return this.urlData;
  }
  getstatelatlnglist() {
    return [
      { "609c5df4-6414-4bbd-a22d-ff5fbdad6836": { "lat": 15.75052353, "lng": 79.95918246 } },
      { "f318279f-537d-4373-b9dc-ac347cdef82f": { "lat": 28.03558532, "lng": 94.67915514 } },
      { "94360caf-ebf0-4303-8c9e-3509bb0cded2": { "lat": 26.35339017, "lng": 92.83150141 } },
      { "ae12d8f1-e36c-445f-8d32-80f958766b4e": { "lat": 25.67950434, "lng": 85.61137064 } },
      { "bd81d570-0e97-4dad-9bcd-219a05f56f2f": { "lat": 21.26687821, "lng": 82.04259117 } },
      { "68dad067-a4cc-4397-a6fd-fc10ef7cc933": { "lat": 11.21548295, "lng": 92.96147365 } },
      { "7f615d2f-0be6-42bf-891f-7239e101e487": { "lat": 15.36140788, "lng": 74.05458945 } },
      { "8fd29251-6e20-4f33-9a96-f47cab45eb13": { "lat": 22.69187442, "lng": 71.58421839 } },
      { "b8c2ccc0-b638-468a-84e7-3512ece9b3a5": { "lat": 31.92444547, "lng": 77.24857939 } },
      { "648a95f6-9249-4c92-8ae4-a9d93eb7c898": { "lat": 29.19663789, "lng": 76.34298073 } },
      { "496bae22-c752-43d6-9bda-7798f9d3b32f": { "lat": 23.65653115, "lng": 85.56455257 } },
      { "eaec6bbb-a219-415f-bdba-991c42586352": { "lat": 14.70980323, "lng": 76.16924288 } },
      { "a1ac5d18-8c9a-4047-8fdd-4d7d9deaa34e": { "lat": 28.64122101, "lng": 77.11890911 } },
      { "e98cd5b7-6556-4c0f-a778-3429e1c14a6b": { "lat": 11.0142095, "lng": 78.40806617 } },
      { "40320284-8d82-4f7e-80d7-00a00bb0e5b0": { "lat": 23.74532195, "lng": 91.74363541 } },
      { "edce8ca7-bf15-4b5e-b4c5-b10c543acd83": { "lat": 26.92101099, "lng": 80.56907097 } },
      { "68ecabb4-0ea5-4909-b8e3-20bbaa7b91e8": { "lat": 23.81632823, "lng": 87.98530363 } },
      { "d19a5290-2e40-494a-83d2-98f4c845b1f1": { "lat": 20.50946561, "lng": 84.42934593 } },
      { "200030a1-6d27-4dff-988a-e2104ff62ab8": { "lat": 30.1531644, "lng": 79.20788586 } },
      { "fd163bec-156c-4633-a7b7-5dfee5fcdf57": { "lat": 11.9824361, "lng": 79.88135654 } },
      { "d6da1adf-2a9c-4908-a356-e7668d4ab108": { "lat": 30.73005735, "lng": 76.78147204 } },
      { "ee1789e0-3831-4cdb-b0b8-77231309cd7e": { "lat": 20.50915748, "lng": 72.25307763 } },
      { "12f0823e-2c16-4765-8137-585b3d5123ac": { "lat": 34.94213006, "lng": 76.78368908 } },
      { "12f0823e-2c16-4765-8137-585b3d5123ac": { "lat": 33.64545154, "lng": 74.85689083 } },
      { "f5c761d1-d9c5-4e5f-af48-2cdfc1c92ce8": { "lat": 20.19660677, "lng": 73.070189 } },
      { "ca25704a-43d0-42ad-bcf4-b2b60270594c": { "lat": 10.44910678, "lng": 76.41027517 } },
      { "5f2a2b2b-cd02-4a00-94ec-3fc97d9f0d19": { "lat": 11.09106187, "lng": 72.73505695 } },
      { "b967d23e-68c8-492c-a372-9623441f7d24": { "lat": 25.53552985, "lng": 91.27943694 } },
      { "0ee3cc5b-1b67-465c-9528-46540aea9cb7": { "lat": 24.73416292, "lng": 93.8812492 } },
      { "f38e6de8-396e-47b4-af18-32c333eddccc": { "lat": 23.53791277, "lng": 78.29225239 } },
      { "e7b3f02d-2497-4bcd-9e20-baa4b621822b": { "lat": 19.45106602, "lng": 76.10590098 } },
      { "812072c8-d651-485c-88e8-7dd29d8c183b": { "lat": 23.3065845, "lng": 92.83677578 } },
      { "37572702-1c31-4723-8328-0a1757f6b4e1": { "lat": 26.06167382, "lng": 94.46996712 } },
      { "5ff5533e-36c5-4c24-abff-1cbbea6f2bdf": { "lat": 30.84284687, "lng": 75.41854256 } },
      { "785cc6f0-e9d0-4961-9578-08ed2f24377a": { "lat": 26.5830166, "lng": 73.85104043 } },
      { "19903c2c-ed18-4782-a679-dc10e8aa71ed": { "lat": 27.57115561, "lng": 88.47735026 } },
      { "a1588b13-5700-450d-b51d-b782ed565801": { "lat": 17.802762, "lng": 79.01088688 } }
    ]
  }
  getLocationRanking(option: object): Observable<any> {
    return this.http.post<any>(this.constants.API_URL + "nmcg/locationranking", option).pipe(
      catchError(this.errorHandler.handleError('get parent child list : ', [])))
  }
  getIndicatorRanking(option: object): Observable<any> {
    return this.http.post<any>(this.constants.API_URL + "nmcg/indicatorranking", option).pipe(
      catchError(this.errorHandler.handleError('get parent child list : ', [])))
  }
  getExtensions(option: object): Observable<any> {
    return this.http.post<any>(this.constants.API_URL + "locations/extension", option).pipe(
      catchError(this.errorHandler.handleError('get parent child list : ', [])))
  }

  getMeeting():Observable<any>{
    return this.http.get<any>(this.constants.API_URL + "nmcg/upload/getMeeting",this.sessionlogin.getHeadersWithCsrf()).pipe(
      catchError(this.errorHandler.handleError('getMeeting ', [])))
  }

}
